import React, { useState, useEffect, createContext } from 'react';
import { useParams, Outlet } from "react-router-dom";
import { doc, getDoc, getDocs, query,collection, where} from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { Typography, useMediaQuery, useTheme 
} from "@mui/material";
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../components/admin/AppNavbar';
import Header from '../components/admin/Header';
import SideMenu from '../components/admin/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../components/admin/theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};


export const EventContext = createContext();

const Dashboard = (props) => {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));


  const navigate = useNavigate();
  const { eventCode } = useParams();  // Capture the eventCode from the URL
  const [event, setEvent] = useState(null);
  const [error, setError] = useState('');
  const [eventDetails, setEventDetails] = useState(null);
  const [eventDocId, setEventDocId] = useState(null);

  // alert("event: " + eventCode); 
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        setError('');
        setEventDetails(null);
        setEventDocId(null);
  
        // Find the event document by eventCode
        const eventsRef = collection(db, 'events');
        const eventQuery = query(eventsRef, where('eventCode', '==', eventCode));
        const eventSnapshot = await getDocs(eventQuery);
  
        if (!eventSnapshot.empty) {
          // Assume the first matching event document
          const eventDoc = eventSnapshot.docs[0];
          const eventData = eventDoc.data();
  
          // Setting the page title 
          { document.title = "nKuvu - " + eventData.eventName }
  
          setEventDocId(eventDoc.id);  // Store document ID for post retrieval
          setEventDetails({
            eventId: eventDoc.id,
            eventImage: eventData.eventImageURL,
            eventName: eventData.eventName,
            eventCode: eventData.eventCode,
            eventDescription: eventData.eventDescription,
            eventOwnerName: eventData.eventOwnerName,
            eventOwnerEmail: eventData.eventOwnerEmail,
            eventLatitude: eventData.eventLatitude,
            eventLongitude: eventData.eventLongitude,
            eventCity: eventData.eventCity,
            eventLocation: eventData.eventLocation,
            eventStartDate: eventData.eventStartDate,
            eventPrice: eventData.eventPrice,
            eventVisibility: eventData.eventVisibility,
            eventFeatured: eventData.featured,
            eventStatus: eventData.eventStatus,
          });
        } else {
          setError('No event found with that event code.');
        }
      } catch (err) {
        console.error("Error fetching event:", err);
        setError('Failed to retrieve event data.');
      }
    };

    fetchEvent();
  }, [eventCode]);

  // if (!event) return <p>Loading event...</p>;

  const myObject = { name: 'John', age: 30 };
  localStorage.setItem('myObject', JSON.stringify(myObject));

  return (

    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
     
      <EventContext.Provider value={{eventDetails}}> 
        {localStorage.setItem('eventName', eventCode)}
        {localStorage.setItem('eventDetails', JSON.stringify(eventDetails))}
       
           
        <Box sx={{ display: 'flex' }}>        
          <SideMenu />      
          <AppNavbar />         
          {/* Main content */}
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: 'auto',
            })}
          > 
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Header />                         
              <Outlet />
              
            </Stack>
          </Box>
        </Box>
      </EventContext.Provider>
    </AppTheme>
  );
};
export default Dashboard;